import { Line, mixins } from "vue-chartjs";

export default Line.extend({
  mixins: [mixins.reactiveProp],
  props: ["chartData", "options"],
  mounted() {
    const options = {
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            gridLines: {
              display: true,
              borderDash: [4],
              color: "#e0e8f0",
              lineWidth: 1
            }
          }
        ]
      },
      maintainAspectRatio: false
    };
    this.renderChart(this.chartData, options);
  }
});
